import React, { useState, useEffect, useCallback } from "react";
import "./styles.scss";
import "./mobile.scss";

import {
  BankInfoCard,
  BankInfoMobileCard,
  Button,
  ButtonIcon,
  FilterCard,
  FilterColor_1,
  FilterColor_3,
  Input,
  MainHeader,
  OfferCardSmall,
  OfferCardSmallShimmer,
  OfferFavoriteCard,
  PreLoader,
  RecentTag,
  SearchCard,
  SectionHeader,
} from "../../components";
import { useSelector, useDispatch } from "react-redux";
import {
  getBank,
  getOfferByBanIdCategoryMultiple,
  getOfferByCategoryByBank,
  getOfferByIdMultiple,
  getTopOffersByBank,
} from "../../service";
import * as actionTypes from "../../store/actions/types";
import { getInsight, userDetails } from "../../utils";
import { useHistory, useLocation } from "react-router-dom/cjs/react-router-dom";
import { Dropdown, Menu } from "antd";
import {
  getFavoriteOfferByUser,
  getLoginUserDetailsById,
} from "../../service/userApi";
import Footer from "../Footer";
import { Helmet } from "react-helmet";
import RestaurantAdCard from "../advertiesment-2";
import { RiArrowLeftSLine, RiArrowRightSLine } from "react-icons/ri";
import Slider from "react-slick";
import {
  getCategoriesWithOffers,
  getCategoryByIdMultiple,
} from "../../service/category";
import { OfferViewModal, ProfileView } from "../modal";
import { GetIcon } from "../../config/icon";
import Scrollbars from "react-custom-scrollbars";
import { HomeRightTopAdd } from "../templates/advertisement";
import { HiDotsVertical } from "react-icons/hi";

// Initial state for the form
const initialDataForm = {
  bank: {
    key: "bank",
    elementType: "input",
    elementConfig: {
      type: "input",
      placeholder: "Bank name type here..",
    },
    value: "",
    validation: {
      required: false,
    },
    valid: false,
    touched: false,
    label: "",
  },
  category: {
    key: "category",
    elementType: "input",
    elementConfig: {
      type: "input",
      placeholder: "Category name type here..",
    },
    value: "",
    validation: {
      required: false,
    },
    valid: false,
    touched: false,
    label: "",
  },
};

// Initial settings for the slider
const initialSettings = {
  variableWidth: true,
  className: "slider variable-width",
  dots: true,
  autoplay: true,
  infinite: true,
  speed: 1000,
  slidesToShow: 10,
  slidesToScroll: 3,
  initialSlide: 0,
  cssEase: "cubic-bezier(0.33, 1, 0.68, 1)",
};

const ViewBank = () => {
  // --- Hooks ---
  const history = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();

  // --- Redux State (from mapStateToProps) ---
  const { insightData, isLogin } = useSelector((state) => ({
    offerData: state.form.offerData,
    insightData: state.insightReducer.insightData,
    isSignUp: state.form.signUp,
    isSignIn: state.form.signIn,
    logInUser: state.user.data,
    isLogin: state.user.isLogin,
  }));

  // --- State (from constructor) ---
  const [viewPointWidth, setViewPointWidth] = useState(0);
  const [viewPointHeight, setViewPointHeight] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingMore, setIsLoadingMore] = useState(false);
  const [isFilterClear, setIsFilterClear] = useState(false);
  const [dataSource, setDataSource] = useState(null);
  const [bankData, setBankData] = useState([]);
  const [topOffersList, setTopOffersList] = useState([]);
  const [topCategoryList, setTopCategoryList] = useState([]);
  const [topBankOffersList, setTopBankOffersList] = useState([]);
  const [topBankCategoryOffersList, setTopBankCategoryOffersList] = useState(
    []
  );
  const [bankList, setBankList] = useState([]);
  const [categoryList, setCategoryList] = useState([]);
  const [categoryData, setCategoryData] = useState(null);
  const [merchantData, setMerchantData] = useState(null);
  const [sessionUser, setSessionUser] = useState(null);
  const [isMobileVerification, setIsMobileVerification] = useState(false);
  const [userFavoritesList, setUserFavoritesList] = useState([]);
  const [filterOffersList, setFilterOffersList] = useState([]);
  const [oldCategory, setOldCategory] = useState("");
  const [selectCategory, setSelectCategory] = useState([]);
  const [isViewAll, setIsViewAll] = useState(false);
  const [isScrollTop, setIsScrollTop] = useState(true);
  const [isViewAllCategoryOffers, setIsViewAllCategoryOffers] = useState(false);
  const [settings, setSettings] = useState(initialSettings);
  const [dataForm, setDataForm] = useState(initialDataForm);
  const [formIsValid, setFormIsValid] = useState(false);
  const [isSticky, setIsSticky] = useState(false);
  // Note: isFavoriteLoading was in state destructuring but not in initial state.
  // Adding it here based on its usage in render().
  const [isFavoriteLoading, setIsFavoriteLoading] = useState(false);

  // --- Redux Actions (from mapDispatchToProps) ---
  const onClickViewMoreOfferDetails = useCallback(
    (payload, categoryData, bankData) =>
      dispatch({
        type: actionTypes.OPEN_OFFER_VIEW_MODAL,
        payload: payload,
        categoryData: categoryData,
        bankData: bankData,
      }),
    [dispatch]
  );

  const openSignupOTP = useCallback(
    (payload) =>
      dispatch({ type: actionTypes.OPEN_OTP_VERIFY, payload: payload }),
    [dispatch]
  );

  const onClickLogOut = useCallback(
    () => dispatch({ type: actionTypes.LOG_OUT }),
    [dispatch]
  );

  const onClickOpenSignUp = useCallback(
    () => dispatch({ type: actionTypes.OPEN_SIGN_UP }),
    [dispatch]
  );

  const onClickOpenSignIn = useCallback(
    () => dispatch({ type: actionTypes.OPEN_SIGN_IN }),
    [dispatch]
  );

  const onClickOpenNewOffer = useCallback(
    () => dispatch({ type: actionTypes.CREATE_NEW_OFFER }),
    [dispatch]
  );

  const onAddLoginUser = useCallback(
    (userDara) =>
      dispatch({ type: actionTypes.ADD_LOGIN_USER, loginUser: userDara }),
    [dispatch]
  );

  const userLogged = useCallback(
    () => dispatch({ type: actionTypes.USER_LOGGED }),
    [dispatch]
  );

  const onClickOpenProfileView = useCallback(
    (payload) =>
      dispatch({ type: actionTypes.OPEN_PROFILE_VIEW, payload: payload }),
    [dispatch]
  );

  const setFilterOptions = useCallback(
    () => dispatch({ type: actionTypes.CLEAR_ALL_FILTER }),
    [dispatch]
  );

  // --- Class Methods (Converted to useCallback) ---

  const handleOnScroll = useCallback(() => {
    let scrollTop =
      (document.documentElement && document.documentElement.scrollTop) ||
      document.body.scrollTop;
    let scrollHeight =
      (document.documentElement && document.documentElement.scrollHeight) ||
      document.body.scrollHeight;
    let clientHeight =
      document.documentElement.clientHeight || window.innerHeight;
    console.log({ scrollTop });
    if (scrollTop <= 100) {
      setIsScrollTop(true);
    } else {
      setIsScrollTop(false);
    }
    console.log({ scrollTop, scrollHeight, clientHeight });
    setIsSticky(scrollTop >= 150);
  }, []); // setIsScrollTop is stable

  const updateWindowDimensions = useCallback(() => {
    setViewPointWidth(window.innerWidth);
    setViewPointHeight(window.innerHeight);
  }, []); // setViewPointWidth/Height are stable

  const fetchCategories = useCallback(async (bankId) => {
    let resultCategory = await getCategoriesWithOffers(bankId);
    console.log({ resultCategory });
    setCategoryList(resultCategory?.data);
    return resultCategory?.data; // Return data for fetchBankData
  }, []); // setCategoryList is stable

  const syncBank = useCallback(async (res) => {
    let resList = [];
    for (let data of res) {
      resList.push({
        ...data,
        isActive: false,
      });
    }
    return resList;
  }, []);

  const getBanks = useCallback(async () => {
    if (bankList.length === 0) {
      let res = await getBank();
      let bankData = res.status ? await syncBank(res.data) : [];
      console.log({ bankData });
      setBankList(bankData);
    }
  }, [bankList.length, syncBank]); // Depends on bankList.length

  const fetchBankData = useCallback(async () => {
    document.querySelector("body").scrollTo(0, 0);
    setIsLoading(true);
    let param = location.pathname;
    param = param.split("/");

    try {
      if (param && param[3] && param[5]) {
        let bankName = param[2];
        let bankId = param[3];
        let categoryName = param[4];
        let categoryId = param[5];

        let fetchedCategoryList = await fetchCategories(bankId); // Use returned data
        let bankData = {
          bankId: bankId,
          bankName: bankName?.replace(/%20/g, " "),
        };
        let categoryData = {
          categoryId: categoryId,
          categoryName: categoryName?.replace(/%20/g, " "),
        };

        setBankData(bankData);
        setCategoryData(categoryData);

        let topBankCategoryOffersList = await getOfferByBanIdCategoryMultiple({
          bankId: bankId,
          categoryIds: [categoryId],
        });

        setTopBankCategoryOffersList(topBankCategoryOffersList?.data);
        setIsLoading(false); // Set loading false after first fetch

        try {
          const insight = await getInsight();
          if (insight?.insightId) {
            const response = await getTopOffersByBank(
              insight?.insightId,
              bankId,
              10
            );

            if (
              response.data.top_offers?.length > 0 ||
              response.data.top_offers?.length > 0
            ) {
              let topCategoryList = await getCategoryByIdMultiple({
                categoryIds: response?.data?.top_categories,
              });
              let topOffersList = await getOfferByIdMultiple({
                offerIds: response?.data?.top_offers,
              });

              setTopOffersList(topOffersList?.data);
              setTopCategoryList(topCategoryList?.data);
              setIsLoading(false);
            }
          }

          let categoryIds = [];
          // Use the freshly fetched category list
          (fetchedCategoryList || []).forEach((element) => {
            categoryIds.push(element?.categoryId);
          });

          if (categoryIds?.length > 0) {
            let topBankOffersList = await getOfferByBanIdCategoryMultiple({
              bankId: bankId,
              categoryIds: categoryIds,
            });
            console.log({ topBankOffersList });

            setTopBankOffersList(topBankOffersList?.data);
            setIsLoading(false);
          }
        } catch (error) {
          setIsLoading(false);
          console.error(error);
        }
      } else {
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
      console.error(error);
    }
  }, [location.pathname, fetchCategories]); // Depends on path and fetchCategories

  const fetchBankOffers = useCallback(async () => {
    let param = location.pathname;
    param = param.split("/");

    try {
      if (param && param[3] && param[5]) {
        let bankId = param[3];
        let categoryIds = [];

        categoryList.forEach((element) => {
          // Uses state categoryList
          categoryIds.push(element?.categoryId);
        });

        if (categoryIds?.length > 0) {
          let topBankOffersList = await getOfferByBanIdCategoryMultiple({
            bankId: bankId,
            categoryIds: categoryIds,
          });
          console.log("topBankOffersList", topBankOffersList.data);

          setTopBankOffersList(topBankOffersList?.data);
          setIsLoading(false);
        } else {
          setTopBankOffersList([]);
          setIsLoading(false);
        }
      } else {
        console.error("Invalid path or parameter not found");
        setIsLoading(false);
      }
    } catch (error) {
      console.error(error);
      setIsLoading(false);
    }
  }, [location.pathname, categoryList]); // Depends on path and categoryList

  const fetchFilterOffers = useCallback(
    async (categoryId) => {
      document.querySelector("body").scrollTo(0, 0);
      setIsLoading(true);
      let param = location.pathname;
      param = param.split("/");

      try {
        if (param && param[3] && param[5]) {
          let bankId = param[3];
          let categoryIds = [categoryId];

          if (categoryIds?.length > 0) {
            let filterResult = await getOfferByBanIdCategoryMultiple({
              bankId: bankId,
              categoryIds: categoryIds,
            });

            setFilterOffersList(filterResult?.data);
            setIsLoading(false);
          }
        } else {
          console.error("Invalid path or parameter not found");
          setIsLoading(false);
        }
      } catch (error) {
        console.error(error);
        setIsLoading(false);
      }
    },
    [location.pathname]
  ); // Depends on path

  const fetchFilterOffersIds = async () => {
    document.querySelector("body").scrollTo(0, 0);
    setIsLoading(true);
    let param = location.pathname;
    param = param.split("/");

    try {
      if (param && param[3] && param[5]) {
        let bankId = param[3];
        let categoryIds = selectCategory;

        if (categoryIds?.length > 0) {
          let filterResult = await getOfferByBanIdCategoryMultiple({
            bankId: bankId,
            categoryIds: categoryIds,
          });

          setFilterOffersList(filterResult?.data);
          setIsLoading(false);
        }
      } else {
        console.error("Invalid path or parameter not found");
        setIsLoading(false);
      }
    } catch (error) {
      console.error(error);
      setIsLoading(false);
    }
  };

  const fetchFilterOffersCategory = useCallback(
    async (categoryId, pageNo) => {
      setIsLoadingMore(true);
      let param = location.pathname;
      param = param.split("/");

      try {
        if (param && param[3] && categoryId && pageNo) {
          let bankId = param[3];

          let filterResult = await getOfferByCategoryByBank(
            bankId,
            categoryId,
            pageNo,
            6
          );

          // Use functional update to safely modify state
          setTopBankOffersList((prevList) => {
            let updateOfferList = [...prevList];
            let categoryOffers = updateOfferList.find(
              (x) => x.categoryId === categoryId
            );
            if (categoryOffers) {
              categoryOffers.offers.push(...filterResult.data);
            }
            return updateOfferList;
          });

          setIsLoadingMore(false);
          setIsLoading(false);
        } else {
          console.error("Invalid path or parameter not found");
          setIsLoading(false);
        }
      } catch (error) {
        console.error(error);
        setIsLoadingMore(false);
        setIsLoading(false);
      }
    },
    [location.pathname]
  ); // Depends on path

  const onClickSelectBank = useCallback(async (bankId) => {
    setBankList((prevBankList) =>
      prevBankList.map((bank) =>
        bank.bankId === bankId
          ? { ...bank, isActive: true }
          : { ...bank, isActive: false }
      )
    );
  }, []); // setBankList is stable

  const getLocationName = useCallback((location) => {
    for (let i = 0; i < location?.length; i++) {
      if (location[i].isActive) {
        return location[i].value;
      }
    }
  }, []);

  const checkIsFavorite = useCallback(
    (offerId) => {
      let isAvailable = false;
      if (userFavoritesList && userFavoritesList.length > 0) {
        for (let i in userFavoritesList) {
          if (userFavoritesList[i]?.offerId === offerId) {
            isAvailable = true;
          }
        }
      }
      return isAvailable;
    },
    [userFavoritesList]
  ); // Depends on userFavoritesList

  const handleNavigate = useCallback(() => {
    history.push("/");
    setFilterOptions();
  }, [history, setFilterOptions]);

  const inputHandleChange = useCallback((event, inputIdentity) => {
    const { value } = event.target;
    setDataForm((prevDataForm) => {
      const updateForm = {
        ...prevDataForm,
      };
      const updatedFormElement = {
        ...updateForm[inputIdentity],
      };
      updatedFormElement.value = value;
      updatedFormElement.touched = true;
      updateForm[inputIdentity] = updatedFormElement;

      // Logic for formIsValid (was in original setState)
      let formIsValid = true;
      for (let inputIdentifier in updateForm) {
        formIsValid = updateForm[inputIdentifier].valid && formIsValid;
      }
      setFormIsValid(formIsValid); // Update formIsValid state

      return updateForm;
    });
  }, []); // setDataForm/setFormIsValid are stable

  const clearAll = useCallback(() => {
    setDataForm((prevDataForm) => {
      const updateForm = { ...prevDataForm };
      for (let key in updateForm) {
        updateForm[key].value = "";
        updateForm[key].valid = false;
        updateForm[key].touched = false;
      }
      return updateForm;
    });
  }, []); // setDataForm is stable

  // --- Lifecycle (componentDidMount/WillUnmount) ---
  useEffect(() => {
    updateWindowDimensions();
    window.addEventListener("resize", updateWindowDimensions);
    window.addEventListener("scroll", handleOnScroll);
    document.querySelector("body").scrollTo(0, 0);

    const loadUserAndBanks = async () => {
      setIsLoading(true); // Set loading here
      let sessionUser = userDetails();
      if (sessionUser?.userId && sessionUser.userType) {
        setSessionUser(sessionUser);
        onAddLoginUser(sessionUser);
        userLogged();
        try {
          let favoriteData = await getFavoriteOfferByUser(sessionUser?.userId);

          if (favoriteData?.status) {
            setIsMobileVerification(favoriteData?.data?.isMobileVerification);
            setUserFavoritesList(favoriteData?.data[0]?.favorites);
            setIsLoading(false);
          }
        } catch (error) {
          console.log(error);
          setIsLoading(false);
        }
      }
      await getBanks();
      setIsLoading(false);
      // fetchBankData is called by the next useEffect
    };

    loadUserAndBanks();

    // Cleanup
    return () => {
      window.removeEventListener("scroll", handleOnScroll);
      window.removeEventListener("resize", updateWindowDimensions);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    dispatch,
    getBanks,
    handleOnScroll,
    updateWindowDimensions,
    onAddLoginUser,
    userLogged,
  ]); // Runs once on mount

  // --- Lifecycle (componentDidUpdate for location.pathname) ---
  useEffect(() => {
    const runFetches = async () => {
      await fetchBankData();
      // await fetchBankOffers(); // This is now handled by the categoryList effect
    };
    runFetches();
  }, [fetchBankData, location.pathname]);

  // --- Lifecycle (componentDidUpdate for categoryList) ---
  useEffect(() => {
    // This check ensures it only runs when categoryList is populated
    if (categoryList?.length > 0) {
      fetchBankOffers();
    }
  }, [categoryList, fetchBankOffers]);

  // --- Render ---

  const banks = (
    <div className={"filter-list"} style={{ zIndex: 1110 }}>
      <div style={{ marginBottom: "8px" }}>
        <Input
          elementConfig={dataForm.bank.elementConfig}
          elementType={dataForm.bank.elementType}
          required={dataForm.bank.validation.required}
          maxLength={dataForm.bank.validation.maxLength}
          invalidReason={dataForm.bank.invalidReason}
          isinvalid={!dataForm.bank.valid}
          touched={dataForm.bank.touched}
          value={dataForm.bank.value}
          size={"sm-search"}
          verificationStatus={dataForm.bank.valid}
          showVerification={!!dataForm.bank.value}
          margin={"m-t-8"}
          label={dataForm.bank.label}
          onClickClear={clearAll}
          changed={(event) => inputHandleChange(event, dataForm.bank.key)}
        />
      </div>
      <div>
        <Scrollbars
          style={{
            height: viewPointHeight - 620,
          }}
          thumbMinSize={30}
          universal={true}
          autoHide
        >
          <>
            {bankList
              ?.filter((item) => {
                if (dataForm["bank"].value === "") {
                  return item;
                } else if (
                  item.bankName
                    ?.toLowerCase()
                    .includes(dataForm["bank"].value.toLowerCase())
                ) {
                  return item;
                }
                return false; // Explicitly return false for non-matches
              })
              .sort((a, b) => {
                return b.isActive - a.isActive;
              })
              .map((item, index) => (
                <SearchCard
                  key={item.bankId || index} // Use a stable key
                  type={"bank"}
                  size={"sm"}
                  imageType={"image"}
                  imgUrl={item.thumbnailURL}
                  remove={false}
                  isSelect={item.isActive}
                  select={false}
                  format={"select-box"}
                  text={item.bankName}
                  onClick={async () => {
                    await onClickSelectBank(item?.bankId);
                    history.push(
                      `/credit-card-offers/${item?.bankName
                        ?.replace(/\s+/g, "-")
                        ?.toLowerCase()}/${
                        item?.bankId
                      }/${categoryData.categoryName
                        ?.replace(/\s+/g, "-")
                        ?.toLowerCase()}/${categoryData.categoryId}`
                    );
                  }}
                />
              ))}
          </>
        </Scrollbars>
      </div>
      {/* <div className="fl__footer"></div> */}
    </div>
  );

  const categories = (
    <div className={"filter-list"} style={{ zIndex: 1110 }}>
      <div style={{ marginBottom: "8px" }}>
        <Input
          elementConfig={dataForm.category.elementConfig}
          elementType={dataForm.category.elementType}
          required={dataForm.category.validation.required}
          maxLength={dataForm.bank.validation.maxLength}
          invalidReason={dataForm.category.invalidReason}
          isinvalid={!dataForm.category.valid}
          touched={dataForm.category.touched}
          value={dataForm.category.value}
          size={"sm-search"}
          verificationStatus={dataForm.category.valid}
          showVerification={!!dataForm.category.value}
          margin={"m-t-8"}
          label={dataForm.category.label}
          onClickClear={clearAll}
          changed={(event) => inputHandleChange(event, dataForm.category.key)}
        />
      </div>
      <div>
        <Scrollbars
          style={{
            height: viewPointHeight - 620,
          }}
          thumbMinSize={30}
          universal={true}
          autoHide
        >
          <>
            {(categoryList || [])
              .slice(5)
              ?.filter((item) => {
                if (dataForm["category"].value === "") {
                  return item;
                } else if (
                  item.categoryName
                    ?.toLowerCase()
                    .includes(dataForm["category"].value.toLowerCase())
                ) {
                  return item;
                }
                return false; // Explicitly return false for non-matches
              })
              .sort((a, b) => {
                if (categoryData?.categoryId === a.categoryId) return -1;
                if (categoryData?.categoryId === b.categoryId) return 1;
                return 0;
              })
              .map((item, index) => (
                <SearchCard
                  key={item.categoryId || index} // Use a stable key
                  type={"bank"}
                  size={"sm"}
                  imageType={"icon"}
                  iconName={
                    categoryData?.categoryId === item.categoryId
                      ? "close"
                      : item?.iconName
                  }
                  remove={false}
                  isSelect={selectCategory?.find((x) => x === item.categoryId)}
                  select={false}
                  format={"select-box"}
                  text={item?.categoryName}
                  onClick={async () => {
                    const updatedCategoryData = {
                      categoryName: item.categoryName,
                      categoryId: item.categoryId,
                    };

                    setSelectCategory([...selectCategory, item.categoryId]);
                    setOldCategory(
                      oldCategory === "" ? categoryData : oldCategory
                    );
                    setIsFilterClear(true);
                    setCategoryData(updatedCategoryData);

                    history.push(
                      `/credit-card-offers/${bankData?.bankName
                        ?.replace(/\s+/g, "-")
                        ?.toLowerCase()}/${
                        bankData?.bankId
                      }/${updatedCategoryData.categoryName
                        ?.replace(/\s+/g, "-")
                        ?.toLowerCase()}/${updatedCategoryData.categoryId}`
                    );

                    await fetchFilterOffers(item.categoryId);
                  }}
                />
              ))}
          </>
        </Scrollbars>
        <div className="fl__footer">
          <Button
            size={"sm"}
            type={"light"}
            reactIcon={""}
            text={"Cancel"}
            rightIcon={false}
            leftIcon={false}
            onClick={function () {
              setSelectCategory([]);
            }}
          />
          <Button
            size={"sm ml-2"}
            type={"dark"}
            reactIcon={""}
            text={`Apply (${selectCategory?.length})`}
            rightIcon={false}
            leftIcon={false}
            onClick={async () => {
              await fetchFilterOffersIds();
            }}
          />
        </div>
      </div>
    </div>
  );

  const profileMenu = (
    <Menu>
      <Menu.Item>
        <a target="_blank" rel="noopener noreferrer">
          Setting
        </a>
      </Menu.Item>
      <Menu.Item>
        <a rel="noopener noreferrer" onClick={() => onClickOpenProfileView()}>
          Portal
        </a>
      </Menu.Item>
      <Menu.Item>
        <a onClick={() => onClickLogOut()} rel="noopener noreferrer">
          Logout
        </a>
      </Menu.Item>
    </Menu>
  );

  return (
    <>
      {/*create new event*/}
      <Helmet>
        <title>
          {`${bankData?.bankName || "Top"} Credit Card Offers - ${
            categoryData?.categoryName || "credit card promotion"
          }`}
        </title>
        {/* */}
        <meta name="keywords" content={bankData?.bankName} />
        <meta
          name="description"
          content={`Explore ${
            bankData?.bankName || "the leading bank's"
          } credit card offers and promotions in Sri Lanka. Discover ${
            categoryData?.categoryName || "exciting deals"
          } and exclusive discounts on CreditCardOffers.lk.`}
        />
        <link
          rel="canonical"
          href={`https://www.creditcardoffers.lk/${
            dataSource?.offerId || "offers"
          }/${bankData?.bankName?.toLowerCase() || "all-banks"}/${
            categoryData?.categoryName?.toLowerCase() || "categories"
          }`}
        />
      </Helmet>

      <Helmet>
        <script type="application/ld+json">
          {`
                {
                  "@context": "https://schema.org",
                  "@type": "WebPage",
                  "name": "${
                    bankData?.bankName || "Top Bank"
                  } Credit Card Offers - ${
            categoryData?.categoryName || "Best Deals"
          } in Sri Lanka",
                  "url": "https://www.creditcardoffers.lk/${
                    dataSource?.offerId || "offers"
                  }/${bankData?.bankName?.toLowerCase() || "all-banks"}/${
            categoryData?.categoryName?.toLowerCase() || "categories"
          }",
                  "description": "Discover ${
                    bankData?.bankName || "top banks"
                  } credit card offers and exclusive ${
            categoryData?.categoryName || "promotions"
          } in Sri Lanka. Stay updated with the best deals on CreditCardOffers.lk.",
                  "mainEntityOfPage": {
                    "@type": "WebPage",
                    "@id": "https://www.creditcardoffers.lk/${
                      dataSource?.offerId || "offers"
                    }/${bankData?.bankName?.toLowerCase() || "all-banks"}/${
            categoryData?.categoryName?.toLowerCase() || "categories"
          }"
                  }
                }
             `}
        </script>
      </Helmet>

      <ProfileView />
      <OfferViewModal />
      <MainHeader
        logInUser={
          sessionUser && sessionUser?.userId && sessionUser?.userType
            ? sessionUser
            : null
        }
        history={history}
        privateUser={require("../../assets/img/default-avatar.jpg")}
        profileMenu={profileMenu}
        onClickOpenNewOffer={onClickOpenNewOffer}
        isLogin={isLogin} // From useSelector
        onClickSignUp={onClickOpenSignUp}
        onClickLogOut={onClickLogOut}
        onClickSignIn={onClickOpenSignIn}
      />

      <div className={"console-inner-wrapper view-offer"} id={"viewOfferId"}>
        <PreLoader isLoading={isLoading} />
        <div className={"top-wrapper"}>
          <div className={"tw__filter-1"}>
            <FilterColor_3 />
          </div>
          <div className={"tw__img-wrap"}>
            <img src={require("../../assets/img/Group 5_2.png")} />
          </div>
          <div className={"tw__filter-2"}>
            <FilterColor_1 />
          </div>
          <div className={"tw__filter-3"}>
            <FilterColor_3 />
          </div>
        </div>

        <div className={"container"}>
          <div className={"row"}>
            {/*======== offer details ========*/}
            <div className={"col-12  "}>
              <div className={"bank-view-page-wrapper d-flex flex-column"}>
                <div className={"Breadcrumb"}>
                  <div className="home-url" onClick={handleNavigate}>
                    Home
                  </div>
                  /
                  <Dropdown overlay={banks}>
                    <div>
                      {bankData?.bankName}
                      {GetIcon("chevronDown")}{" "}
                    </div>
                  </Dropdown>
                  {/* / {bankData?.bankId?.substring(0, 17).trimEnd() + "..."} */}
                </div>

                <div className={"row"}>
                  {/*==== OFFER VIEW PAGE====*/}
                  <div
                    className={`col-3 bvpw__left-wrp ${
                      !isScrollTop ? "sticky" : ""
                    }`}
                  >
                    <div className="bank-card-wrapper">
                      <BankInfoCard
                        bankId={bankData?.bankId}
                        logo={bankData?.logoURL}
                        name={bankData?.bankName}
                        categoryName={categoryData?.categoryName}
                        categoryId={categoryData?.categoryId}
                        topOffersList={topOffersList}
                        favCount={"1K"}
                      />
                    </div>
                    <div style={{ marginBottom: "217px" }}>
                      <HomeRightTopAdd />
                    </div>
                  </div>

                  <div className={"col-9  bvpw__right-wrp"}>
                    {/*======== mobile bank card start ========*/}
                    <div className={"mobile-bank-card"}>
                      <BankInfoMobileCard
                        bankId={bankData?.bankId}
                        logo={bankData?.logoURL}
                        name={bankData?.bankName}
                        categoryName={categoryData?.categoryName}
                        categoryId={categoryData?.categoryId}
                        topOffersList={topOffersList}
                      />
                    </div>
                    {/*======== mobile bank card end ========*/}
                    {!isLoading && (
                      <>
                        {/*======== recent-view-tag ========*/}
                        <div
                          className={`recent-views-wrapper d-flex flex-column ${
                            !isScrollTop ? "fix-top active-shadow" : ""
                          }`}
                        >
                          {categoryList?.length > 0 && (
                            <div className={"rvw__title"}>Recent view</div>
                          )}

                          <div className={"rvw__recent-cards d-flex flex-row"}>
                            {categoryList?.length > 5 ? (
                              <Slider
                                {...settings}
                                className={
                                  "rpmw__slider d-flex flex-row justify-content-center pt-3"
                                }
                              >
                                {(categoryList || [])
                                  .slice(0, 5)
                                  .sort((a, b) => {
                                    if (
                                      categoryData?.categoryId === a.categoryId
                                    )
                                      return -1;
                                    if (
                                      categoryData?.categoryId === b.categoryId
                                    )
                                      return 1;
                                    return 0;
                                  })
                                  .map((item, index) => (
                                    <RecentTag
                                      key={index}
                                      iconName={
                                        categoryData?.categoryId ===
                                        item.categoryId
                                          ? "close"
                                          : item?.iconName
                                      }
                                      isActive={
                                        categoryData?.categoryId ===
                                        item.categoryId
                                      }
                                      title={item?.categoryName}
                                      onClick={async () => {
                                        const updatedCategoryData = {
                                          categoryName: item.categoryName,
                                          categoryId: item.categoryId,
                                        };

                                        setOldCategory(
                                          oldCategory === ""
                                            ? categoryData
                                            : oldCategory
                                        );
                                        setIsFilterClear(true);
                                        setCategoryData(updatedCategoryData);

                                        history.push(
                                          `/credit-card-offers/${bankData?.bankName
                                            ?.replace(/\s+/g, "-")
                                            ?.toLowerCase()}/${
                                            bankData?.bankId
                                          }/${updatedCategoryData.categoryName
                                            ?.replace(/\s+/g, "-")
                                            ?.toLowerCase()}/${
                                            updatedCategoryData.categoryId
                                          }`
                                        );

                                        await fetchFilterOffers(
                                          item.categoryId
                                        );
                                      }}
                                    />
                                  ))}
                              </Slider>
                            ) : (
                              <div className="rpmw__slider d-flex flex-row justify-content-center gap-2">
                                {(categoryList || [])
                                  .sort((a, b) => {
                                    if (
                                      categoryData?.categoryId === a.categoryId
                                    )
                                      return -1;
                                    if (
                                      categoryData?.categoryId === b.categoryId
                                    )
                                      return 1;
                                    return 0;
                                  })
                                  .map((item, index) => (
                                    <RecentTag
                                      key={index}
                                      iconName={
                                        categoryData?.categoryId ===
                                        item.categoryId
                                          ? "close"
                                          : item?.iconName
                                      }
                                      isActive={
                                        categoryData?.categoryId ===
                                        item.categoryId
                                      }
                                      title={item?.categoryName}
                                      onClick={async () => {
                                        const updatedCategoryData = {
                                          categoryName: item.categoryName,
                                          categoryId: item.categoryId,
                                        };

                                        setOldCategory(
                                          oldCategory === ""
                                            ? categoryData
                                            : oldCategory
                                        );
                                        setIsFilterClear(true);
                                        setCategoryData(updatedCategoryData);

                                        history.push(
                                          `/credit-card-offers/${bankData?.bankName
                                            ?.replace(/\s+/g, "-")
                                            ?.toLowerCase()}/${
                                            bankData?.bankId
                                          }/${updatedCategoryData.categoryName
                                            ?.replace(/\s+/g, "-")
                                            ?.toLowerCase()}/${
                                            updatedCategoryData.categoryId
                                          }`
                                        );

                                        await fetchFilterOffers(
                                          item.categoryId
                                        );
                                      }}
                                    />
                                  ))}
                              </div>
                            )}
                          </div>
                        </div>
                        {categoryList?.length > 5 && (
                          <Dropdown overlay={categories}>
                            <div className="rvw__rc-more">
                              <ButtonIcon
                                buttonIcon={<HiDotsVertical />}
                                type={"round x"}
                                size={"md"}
                              />
                            </div>
                          </Dropdown>
                        )}

                        {filterOffersList?.length === 0 && !isFilterClear && (
                          <>
                            {/*======== favorite offers ========*/}
                            {!isViewAllCategoryOffers && (
                              <div
                                className={
                                  "recent-view-cards-wrapper xl d-flex flex-column"
                                }
                              >
                                {(topOffersList?.length > 0 ||
                                  userFavoritesList?.length > 0) && (
                                  <>
                                    <div className={"rvcw__border"}>
                                      <div
                                        className={
                                          "rvcw__header d-flex flex-row"
                                        }
                                      >
                                        <div className={"rvcw__h-title"}>
                                          <SectionHeader
                                            text={
                                              topOffersList?.length > 0
                                                ? "Your recently viewed offers"
                                                : "Favorite"
                                            }
                                            size={"md"}
                                          />
                                        </div>
                                        <div
                                          className={"rvcw__h-action"}
                                          onClick={() =>
                                            setIsViewAll(!isViewAll)
                                          }
                                        >
                                          {isViewAll ? "Less" : "View all"}
                                        </div>
                                      </div>
                                      {/* user favorites */}
                                      {topOffersList?.length === 0 && (
                                        <>
                                          {!isViewAll && (
                                            <div
                                              className={`rvcw__offer-list favourite ${
                                                isViewAllCategoryOffers
                                                  ? "d-flex flex-column"
                                                  : ""
                                              }`}
                                            >
                                              {(userFavoritesList || [])
                                                .slice(0, 3)
                                                .map((item, index) => (
                                                  <OfferFavoriteCard
                                                    key={
                                                      item?.offer?.offerId ||
                                                      index
                                                    }
                                                    status={item?.offer?.status}
                                                    location={getLocationName(
                                                      item?.offer?.location
                                                    )}
                                                    bannerUrl={
                                                      item?.offer
                                                        ?.bannerImageURL
                                                    }
                                                    logoUrl={
                                                      item?.merchant?.logoURL
                                                    }
                                                    categoryIcon={
                                                      item?.category?.iconName
                                                    }
                                                    merchantName={
                                                      item?.merchant
                                                        ?.merchantName.length >
                                                      20
                                                        ? item?.merchant?.merchantName
                                                            ?.substring(0, 20)
                                                            .trimEnd() + "..."
                                                        : item?.merchant
                                                            ?.merchantName
                                                    }
                                                    header={
                                                      item?.offer?.header
                                                        ?.length > 20
                                                        ? item?.offer?.header
                                                            ?.substring(0, 20)
                                                            .trimEnd() + "..."
                                                        : item?.offer?.header
                                                    }
                                                    isLoading={isLoading}
                                                    onClick={() => {
                                                      const generatedSlug =
                                                        item.bank?.bankName
                                                          ?.replace(/\s+/g, "-")
                                                          ?.toLowerCase() +
                                                        "-credit-card-offers";
                                                      history.push(
                                                        `/${generatedSlug}/${item.category?.categoryName
                                                          ?.replace(/\s+/g, "-")
                                                          ?.toLowerCase()
                                                          ?.replace(/\s+/g, "-")
                                                          ?.toLowerCase()}/${
                                                          item.offerId
                                                        }`
                                                      );
                                                    }}
                                                  />
                                                ))}
                                            </div>
                                          )}
                                          {isViewAll && (
                                            <div
                                              className={`rvcw__offer-list ${
                                                isViewAllCategoryOffers
                                                  ? "d-flex flex-column"
                                                  : ""
                                              }`}
                                            >
                                              {(userFavoritesList || []).map(
                                                (item, index) => (
                                                  <OfferCardSmall
                                                    key={item?.offer?.offerId}
                                                    id={`${item?.offer?.offerId}`}
                                                    animate={"animate__fadeIn"}
                                                    size={"sm"}
                                                    type={"favourite"}
                                                    isFavorites={checkIsFavorite(
                                                      item?.offer?.offerId
                                                    )}
                                                    isLoading={isLoading}
                                                    data={{
                                                      ...item?.offer,
                                                      bank: item?.bank,
                                                      category: item?.category,
                                                      merchant: item?.merchant,
                                                    }}
                                                    onClick={() => {
                                                      const generatedSlug =
                                                        item.bank?.bankName
                                                          ?.replace(/\s+/g, "-")
                                                          ?.toLowerCase() +
                                                        "-credit-card-offers";
                                                      history.push(
                                                        `/${generatedSlug}/${item.category?.categoryName
                                                          ?.replace(/\s+/g, "-")
                                                          ?.toLowerCase()
                                                          ?.replace(/\s+/g, "-")
                                                          ?.toLowerCase()}/${
                                                          item.offerId
                                                        }`
                                                      );
                                                    }}
                                                  />
                                                )
                                              )}
                                            </div>
                                          )}
                                        </>
                                      )}
                                      {/* top offers */}
                                      {topOffersList?.length > 0 && (
                                        <>
                                          {!isViewAll && (
                                            <div
                                              className={`rvcw__offer-list favourite ${
                                                isViewAllCategoryOffers
                                                  ? "d-flex flex-column"
                                                  : ""
                                              }`}
                                            >
                                              {(topOffersList || [])
                                                .slice(0, 3)
                                                .map((item, index) => (
                                                  <OfferFavoriteCard
                                                    key={item?.offerId || index}
                                                    status={item?.status}
                                                    location={getLocationName(
                                                      item?.location
                                                    )}
                                                    bannerUrl={
                                                      item?.bannerImageURL
                                                    }
                                                    logoUrl={
                                                      item?.merchantData
                                                        ?.logoURL
                                                    }
                                                    categoryIcon={
                                                      item?.category?.iconName
                                                    }
                                                    merchantName={
                                                      item?.merchantData
                                                        ?.merchantName.length >
                                                      20
                                                        ? item?.merchantData?.merchantName
                                                            ?.substring(0, 20)
                                                            .trimEnd() + "..."
                                                        : item?.merchantData
                                                            ?.merchantName
                                                    }
                                                    header={
                                                      item?.header?.length > 20
                                                        ? item?.header
                                                            ?.substring(0, 20)
                                                            .trimEnd() + "..."
                                                        : item?.header
                                                    }
                                                    // isLoading={isFavoriteLoading}
                                                    onClick={() => {
                                                      const generatedSlug =
                                                        item.bank?.bankName
                                                          ?.replace(/\s+/g, "-")
                                                          ?.toLowerCase() +
                                                        "-credit-card-offers";
                                                      history.push(
                                                        `/${generatedSlug}/${item.category?.categoryName
                                                          ?.replace(/\s+/g, "-")
                                                          ?.toLowerCase()
                                                          ?.replace(/\s+/g, "-")
                                                          ?.toLowerCase()}/${
                                                          item.offerId
                                                        }`
                                                      );
                                                    }}
                                                  />
                                                ))}
                                            </div>
                                          )}
                                          {isViewAll && (
                                            <div
                                              className={`rvcw__offer-list ${
                                                isViewAllCategoryOffers
                                                  ? "d-flex flex-column"
                                                  : ""
                                              }`}
                                            >
                                              {(topOffersList || []).map(
                                                (item, index) => (
                                                  <OfferCardSmall
                                                    key={item?.offerId}
                                                    id={`${item?.offerId}`}
                                                    animate={"animate__fadeIn"}
                                                    size={"sm"}
                                                    type={"favourite"}
                                                    isFavorites={checkIsFavorite(
                                                      item?.offerId
                                                    )}
                                                    isLoading={isLoading}
                                                    data={item}
                                                    onClick={() => {
                                                      const generatedSlug =
                                                        item.bank?.bankName
                                                          ?.replace(/\s+/g, "-")
                                                          ?.toLowerCase() +
                                                        "-credit-card-offers";
                                                      history.push(
                                                        `/${generatedSlug}/${item.category?.categoryName
                                                          ?.replace(/\s+/g, "-")
                                                          ?.toLowerCase()
                                                          ?.replace(/\s+/g, "-")
                                                          ?.toLowerCase()}/${
                                                          item.offerId
                                                        }`
                                                      );
                                                    }}
                                                  />
                                                )
                                              )}
                                            </div>
                                          )}
                                        </>
                                      )}
                                    </div>
                                  </>
                                )}
                              </div>
                            )}

                            {/* recent view category */}
                            {!isViewAllCategoryOffers &&
                              topCategoryList?.length > 0 && (
                                <div
                                  className={
                                    "recent-view-cards-wrapper d-flex flex-column mb-5"
                                  }
                                >
                                  <>
                                    <div className={"rvcw__border"}>
                                      <div
                                        className={
                                          "rvcw__header d-flex flex-row justify-content-start"
                                        }
                                      >
                                        <div className={"rvcw__h-title"}>
                                          <SectionHeader
                                            text={"Recent view"}
                                            size={"x-sm"}
                                          />
                                        </div>
                                      </div>
                                      <div className={"rvcw__category-list"}>
                                        {(topCategoryList || []).map(
                                          (item, index) => (
                                            <div
                                              className="d-flex"
                                              key={item.categoryId || index}
                                            >
                                              <RecentTag
                                                iconName={
                                                  categoryData?.categoryId ===
                                                  item.categoryId
                                                    ? "close"
                                                    : item?.iconName
                                                }
                                                isActive={
                                                  categoryData?.categoryId ===
                                                  item.categoryId
                                                }
                                                title={item?.categoryName}
                                                onClick={async () => {
                                                  const updatedCategoryData = {
                                                    categoryName:
                                                      item.categoryName,
                                                    categoryId: item.categoryId,
                                                  };
                                                  setOldCategory(
                                                    oldCategory === ""
                                                      ? categoryData
                                                      : oldCategory
                                                  );
                                                  setIsFilterClear(true);
                                                  setCategoryData(
                                                    updatedCategoryData
                                                  );

                                                  history.push(
                                                    `/credit-card-offers/${bankData?.bankName
                                                      ?.replace(/\s+/g, "-")
                                                      ?.toLowerCase()}/${
                                                      bankData?.bankId
                                                    }/${updatedCategoryData.categoryName
                                                      ?.replace(/\s+/g, "-")
                                                      ?.toLowerCase()}/${
                                                      updatedCategoryData.categoryId
                                                    }`
                                                  );
                                                  await fetchFilterOffers(
                                                    item.categoryId
                                                  );
                                                }}
                                              />
                                            </div>
                                          )
                                        )}
                                      </div>
                                    </div>
                                  </>
                                </div>
                              )}

                            {/* offers for bank top categories */}
                            {topBankOffersList?.length > 0 && (
                              <div
                                className={
                                  "recent-view-cards-wrapper d-flex flex-column"
                                }
                              >
                                {(topBankOffersList || []).map(
                                  (item, index) => (
                                    <React.Fragment
                                      key={item.categoryId || index}
                                    >
                                      <div className={"rvcw__border"}>
                                        <div
                                          className={
                                            "rvcw__header d-flex flex-row justify-content-start"
                                          }
                                        >
                                          <div className="rcvw__h-icon">
                                            {GetIcon(item?.iconName)}
                                          </div>
                                          <div className={"rvcw__h-title "}>
                                            <SectionHeader
                                              text={item?.categoryName}
                                              size={"md"}
                                            />
                                          </div>
                                        </div>
                                        <div
                                          className={`rvcw__offer-list ${
                                            isViewAllCategoryOffers
                                              ? "d-flex flex-column"
                                              : ""
                                          }`}
                                        >
                                          {item?.offers?.length > 0 && (
                                            <>
                                              {!isViewAllCategoryOffers &&
                                                (item?.offers || []).map(
                                                  (item, index) => (
                                                    <div
                                                      className="d-flex"
                                                      key={
                                                        item?.offerId || index
                                                      }
                                                    >
                                                      <OfferCardSmall
                                                        id={`${item?.offerId}`}
                                                        animate={
                                                          "animate__fadeIn"
                                                        }
                                                        size={"sm"}
                                                        type={"favourite"}
                                                        isFavorites={checkIsFavorite(
                                                          item?.offerId
                                                        )}
                                                        isLoading={isLoading}
                                                        data={item}
                                                        onClick={() => {
                                                          const generatedSlug =
                                                            item.bank?.bankName
                                                              ?.replace(
                                                                /\s+/g,
                                                                "-"
                                                              )
                                                              ?.toLowerCase() +
                                                            "-credit-card-offer";
                                                          history.push(
                                                            `/${generatedSlug}/${item.category?.categoryName
                                                              ?.replace(
                                                                /\s+/g,
                                                                "-"
                                                              )
                                                              ?.toLowerCase()
                                                              ?.replace(
                                                                /\s+/g,
                                                                "-"
                                                              )
                                                              ?.toLowerCase()}/${
                                                              item.offerId
                                                            }`
                                                          );
                                                        }}
                                                      />
                                                    </div>
                                                  )
                                                )}
                                            </>
                                          )}
                                        </div>
                                        {!isLoading &&
                                          item.totalCount -
                                            item?.offers?.length >
                                            0 && (
                                            <div
                                              className={
                                                "console__load-more-wrp d-flex align-items-center justify-content-center mt-3 "
                                              }
                                            >
                                              <Button
                                                size={"xl x"}
                                                type={"light"}
                                                isLoading={isLoadingMore}
                                                onClick={async () => {
                                                  if (
                                                    item?.offers?.length > 0
                                                  ) {
                                                    let pageNo =
                                                      item?.offers?.length / 6 +
                                                      1;
                                                    await fetchFilterOffersCategory(
                                                      item?.categoryId,
                                                      pageNo
                                                    );
                                                  }
                                                }}
                                                text={`Load more offers (${
                                                  item.totalCount -
                                                  item?.offers?.length
                                                })`}
                                              />
                                            </div>
                                          )}
                                      </div>
                                    </React.Fragment>
                                  )
                                )}
                              </div>
                            )}
                          </>
                        )}
                        {(filterOffersList?.length > 0 || isFilterClear) && (
                          <>
                            {/* offers for bank top categories */}

                            <div
                              className={
                                "recent-view-cards-wrapper xl d-flex flex-column"
                              }
                            >
                              {filterOffersList?.length === 0 &&
                                isFilterClear && (
                                  <>
                                    <div className={"rvcw__border"}>
                                      <div
                                        className={
                                          "rvcw__header d-flex flex-row mt-2 justify-content-start"
                                        }
                                      >
                                        <div className={"rvcw__h-title"}>
                                          <SectionHeader
                                            text={categoryData?.categoryName}
                                            size={"md"}
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  </>
                                )}
                              {filterOffersList?.length > 0 &&
                                (filterOffersList || []).map((item, index) => (
                                  <React.Fragment
                                    key={item.categoryId || index}
                                  >
                                    <div className={"rvcw__border"}>
                                      <div
                                        className={
                                          "rvcw__header d-flex flex-row mt-2 justify-content-start"
                                        }
                                      >
                                        <div className="rcvw__h-icon">
                                          {GetIcon(item?.iconName)}
                                        </div>
                                        <div className={"rvcw__h-title"}>
                                          <SectionHeader
                                            text={item?.categoryName}
                                            size={"md"}
                                          />
                                        </div>
                                      </div>
                                      <div
                                        className={`rvcw__offer-list ${
                                          isViewAllCategoryOffers
                                            ? "d-flex flex-column"
                                            : ""
                                        }`}
                                      >
                                        {item?.offers?.length > 0 && (
                                          <>
                                            {!isViewAllCategoryOffers &&
                                              (item?.offers || []).map(
                                                (offerItem, index) => (
                                                  <div
                                                    className="d-flex"
                                                    key={
                                                      offerItem?.offerId ||
                                                      index
                                                    }
                                                  >
                                                    <OfferCardSmall
                                                      id={`${offerItem?.offerId}`}
                                                      animate={
                                                        "animate__fadeIn"
                                                      }
                                                      size={"sm"}
                                                      type={"favourite"}
                                                      isFavorites={checkIsFavorite(
                                                        offerItem?.offerId
                                                      )}
                                                      isLoading={isLoading}
                                                      data={offerItem}
                                                      onClick={() => {
                                                        const generatedSlug =
                                                          offerItem.bank?.bankName
                                                            ?.replace(
                                                              /\s+/g,
                                                              "-"
                                                            )
                                                            ?.toLowerCase() +
                                                          "-credit-card-offers";
                                                        history.push(
                                                          `/${generatedSlug}/${offerItem.category?.categoryName
                                                            ?.replace(
                                                              /\s+/g,
                                                              "-"
                                                            )
                                                            ?.toLowerCase()
                                                            ?.replace(
                                                              /\s+/g,
                                                              "-"
                                                            )
                                                            ?.toLowerCase()}/${
                                                            offerItem.offerId
                                                          }`
                                                        );
                                                      }}
                                                    />
                                                  </div>
                                                )
                                              )}
                                          </>
                                        )}
                                      </div>
                                      {!isLoading &&
                                        item.totalCount - item?.offers?.length >
                                          0 && (
                                          <div
                                            className={
                                              "console__load-more-wrp d-flex align-items-center justify-content-center mt-3 "
                                            }
                                          >
                                            <Button
                                              size={"xl x"}
                                              type={"light"}
                                              isLoading={isLoadingMore}
                                              onClick={async () => {
                                                if (item?.offers?.length > 0) {
                                                  let pageNo =
                                                    item?.offers?.length / 6 +
                                                    1;
                                                  await fetchFilterOffersCategory(
                                                    item?.categoryId,
                                                    pageNo
                                                  );
                                                }
                                              }}
                                              text={`Load more offers (${
                                                item.totalCount -
                                                item?.offers?.length
                                              })`}
                                            />
                                          </div>
                                        )}
                                    </div>
                                  </React.Fragment>
                                ))}
                            </div>
                          </>
                        )}
                        {(isFilterClear || filterOffersList?.length > 0) && (
                          <div
                            className={`clear-btn animate__animated ${
                              isFilterClear ? "animate__fadeInUp" : ""
                            }`}
                          >
                            <FilterCard
                              type={"clear"}
                              isText={true}
                              isActive={true}
                              iconLeft={""}
                              text={"Clear all"}
                              isRadioBtn={true}
                              isRemove={true}
                              onClickClear={() => {
                                setFilterOffersList([]);
                                const updatedCategoryData = {
                                  categoryName: oldCategory.categoryName,
                                  categoryId: oldCategory.categoryId,
                                };

                                setOldCategory("");
                                setIsFilterClear(false);
                                setIsViewAllCategoryOffers(false);
                                setCategoryData(updatedCategoryData);

                                history.push(
                                  `/credit-card-offers/${bankData?.bankName
                                    ?.replace(/\s+/g, "-")
                                    ?.toLowerCase()}/${
                                    bankData?.bankId
                                  }/${updatedCategoryData.categoryName
                                    ?.replace(/\s+/g, "-")
                                    ?.toLowerCase()}/${
                                    updatedCategoryData.categoryId
                                  }`
                                );

                                document.querySelector("body").scrollTo(0, 0);
                              }}
                            />
                          </div>
                        )}
                      </>
                    )}
                    {isLoading && (
                      <div
                        className="rvcw__offer-list"
                        style={{
                          marginTop: "15%",
                          background: "#ffff",
                          padding: "16px",
                          borderRadius: "16px",
                        }}
                      >
                        <OfferCardSmallShimmer />
                        <OfferCardSmallShimmer />
                        <OfferCardSmallShimmer />
                        <OfferCardSmallShimmer />
                        <OfferCardSmallShimmer />
                        <OfferCardSmallShimmer />
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div>
        <Footer />
      </div>
    </>
  );
};

// Remove mapStateToProps and mapDispatchToProps
// The export default no longer needs connect() or withRouter()
// as hooks (useSelector, useDispatch, useHistory, useLocation) are used instead.
export default ViewBank;
